import React from 'react'
import {
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    Table
} from "reactstrap";

const UnusedViews = (props) => {
    const {view, getBackBtn} = props
    
    const raportTitles = {
        1: 'Raport po podziale kosztów',
        2: 'Sumaryczne zestawienie kosztów całkowitych ośrodków powstawania kosztów',
        3.1: 'Sumaryczne zestawienie kosztów rodzajowych według kont analitycznych - struktura',
        3.2: 'Sumaryczne zestawienie kosztów rodzajowych według kont analitycznych - dynamika',
        4: 'Koszt całkowity ośrodka powstawania kosztów - analityka',
        5: 'Koszty bezpośrednie ośrodka powstawania kosztów (analityka kont zespołu 4)',
        6: 'Koszty bezpośrednie ośrodków powstawania kosztów (grupy kosztów kont zespołu 4)',
        7: 'Koszty przeniesione na ośrodki powstawania kosztów poprzez zlecone usługi/procedury  - według ośrodka wykonującego',
        8: 'Koszty przeniesione na  ośrodki powstawania kosztów poprzez zlecone usługi/procedury - według ośrodka zlecającego',
        9: 'Zestawienie jednostkowych kosztów wytworzenia procedur medycznych',
        10: 'Koszty jednostkowe normatywne i koszty wytworzenia procedur medycznych - porównanie'
    }
    const reportNumbers = [1, 2, 3.1, 3.2, 4, 5, 6, 7, 8, 9, 10]

    return (<>
        {view === 'import' &&
            <Card>
                <CardHeader>
                    <CardTitle tag="h5">
                        Import danych​
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <div style={{textAlign: 'justify'}}>
                        W tym module w prosty sposób zaimportujecie Państwo dane wprowadzone uprzednio do pliku
                        Excel według określonego szablonu lub macie możliwość wprowadzenia danych bezpośrednio w
                        Aplikacji za pomocą dedykowanego arkusza z interaktywnymi polami.​
                        <br/>
                        Użytkownik przy pierwszym logowaniu uzupełnia strukturę kont zespołu 4 oraz zespołu 5,
                        klucze podziałowe i wykaz realizowanych procedur medycznych wraz ze wskazaniem, czy chce
                        dokonać kalkulacji kosztów normatywnych procedur w systemie, czy poza systemem. W
                        kolejnych miesiącach wgrywa plik z danymi z systemu finansowo-księgowego oraz dane
                        statystyczne dotyczące wykonań procedur/usług w danym okresie.​
                    </div>
                    <br/>
                    Moduł wprowadzania danych stwarza użytkownikowi możliwości:​
                    <ul>
                        <li>zaimportowania danych z pliku Excel</li>
                        <li>wprowadzenia wybranych danych ręcznie</li>
                        <li>zapisania wersji roboczej na dowolnym etapie prac</li>
                        <li>edytowania wprowadzonych danych</li>
                        <li>przeglądania historii wprowadzonych danych</li>
                        <li>zapoznania się z warunkami przesłania danych</li>
                        <li>zaakceptowania/odrzucenia warunków przesłania danych​</li>
                        <li>przesłania danych do AOTMiT​</li>
                        <li>rozliczenia kosztów działalności pomocniczej medycznej i niemedycznej, OPK
                            proceduralnych oraz kosztów zarządu
                        </li>
                    </ul>
                    {getBackBtn()}
                </CardBody>
            </Card>
            }
            {view === 'wycena' &&
            <Card>
                <CardHeader>
                    <CardTitle tag="h5">
                        Wycena procedur medycznych​
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <div style={{textAlign: 'justify'}}>
                        Moduł umożliwi podmiotom dokonanie w systemie wyceny procedur medycznych w oparciu o
                        koszty typowo zużywanych zasobów, które świadczeniodawca może zdefiniować w systemie lub
                        zaimplementować w formie plików Excel. Aplikacja daje możliwość użytkownikowi wyboru
                        metody ustalenia kosztów pośrednich dla danego rodzaju OPK proceduralnego.
                    </div>
                    <br/>
                    Moduł wyceny procedur medycznych stwarza możliwość:​
                    <ul>
                        <li>zaimportowania wyceny procedur przy pomocy szablonu w pliku Excel, gdy została
                            dokonana poza aplikacją
                        </li>
                        <li>zaimportowania słowników cen materiałów bezpośrednich i stawek personelu medycznego,
                            zdefiniowania zużytych zasobów na poziomie procedury w Aplikacji​
                        </li>
                        <li>wyceny jednostkowych kosztów normatywnych procedur</li>
                        <li>prostego sposobu cyklicznej aktualizacji wyceny procedur​</li>
                    </ul>
                    {getBackBtn()}
                </CardBody>
            </Card>
            }
            {view === 'raporty' &&
            <Card>
                <CardHeader>
                    <CardTitle tag="h5">
                        Raporty
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <div style={{textAlign: 'justify'}}>
                        Moduł będzie dostarczał użytkownikowi gotowe raporty zawierające najistotniejsze
                        informacje zarządcze, umożliwi użytkownikowi także przeglądanie uporządkowanych danych
                        według wybranych przez niego filtrów. Największym atutem tego modułu jest stworzenie dla
                        kadry zarządzającej pulpitu menadżerskiego, który umożliwia jednoczesną prezentację
                        danych z wielu źródeł, co pozwala​
                        na wielowymiarowe analizy danych „od ogółu do szczegółu”. Umożliwi to kadrze
                        zarządzającej bieżącą ocenę sytuacji finansowej podmiotu oraz podejmowanie właściwych
                        decyzji zarządczych. ​
                        <br/>
                        Dane w module będą prezentowane w formie wykresów, tabel i kafelków.
                    </div>
                    <br/>
                    W Module raportowym, świadczeniodawca będzie mógł:​
                    <ul>
                        <li>przejrzeć wprowadzone dane w formie tabelarycznej​</li>
                        <li>filtrować zakres wprowadzonych danych według zdefiniowanych atrybutów​</li>
                        <li>wygenerować wykresy na podstawie wprowadzonych danych</li>
                        <li>wygenerować raport w formacje PDF</li>
                    </ul>
                    <Table style={{borderCollapse: 'collapse'}}>
                        <thead className='text-center' style={{color: 'black'}}>
                        <tr style={{backgroundColor: 'rgb(91, 154, 203, 0.6)'}}>
                            <th rowSpan={2} style={{border: '1px solid #dee2e6 !important;'}}>Lp.</th>
                            <th rowSpan={2} style={{border: '1px solid #dee2e6 !important;'}}>Nazwa raportu</th>
                            <th colSpan={2} style={{border: '1px solid #dee2e6 !important;'}}>Warianty</th>
                        </tr>
                        <tr style={{backgroundColor: 'rgb(155, 194, 230, 0.6)'}}>
                            <th style={{border: '1px solid #dee2e6 !important;'}}>miesięcznie</th>
                            <th style={{border: '1px solid #dee2e6 !important;'}}>narastająco</th>
                        </tr>
                        </thead>
                        <tbody>
                        {reportNumbers.map((nr, i) => {
                            return (<tr key={i}>
                                <td>{nr}</td>
                                <td>{raportTitles[nr]}</td>
                                <td className='text-center'>TAK</td>
                                {nr === 1 || nr === 10 ? <td className='text-center'>NIE</td> :
                                    <td className='text-center'>TAK</td>}
                            </tr>)
                        })}

                        </tbody>
                    </Table>
                    {getBackBtn()}
                </CardBody>
            </Card>
            }
            {view === 'wskazniki' &&
            <Card>
                <CardHeader>
                    <CardTitle tag="h5">
                        Wskaźniki finansowo-ekonomiczne
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <div style={{textAlign: 'justify'}}>
                        Moduł pozwoli użytkownikowi na uzyskanie informacji o wartości podstawowych wskaźników
                        ekonomiczno-finansowych i statystycznych na poziomie całego podmiotu oraz poszczególnych
                        ośrodków powstawania kosztów, a także stworzy możliwość porównywania ich wyników na tle
                        innych podmiotów (zanonimizowane dane).​
                    </div>
                    <br/>
                    Moduł wskaźników stwarza użytkownikowi możliwość:
                    <ul>
                        <li>wyboru zakresu prezentowanych wykresów według zdefiniowanych atrybutów</li>
                        <li>wygenerowania wykresów</li>
                        <li>zobrazowania wskaźników w ujęciu porównawczym względem innych podmiotów</li>
                        <li>wygenerowania raportu w formacie PDF</li>
                    </ul>
                    {getBackBtn()}
                </CardBody>
            </Card>
            }
            {view === 'pulpit' &&
            <Card>
                <CardHeader>
                    <CardTitle tag="h5">
                        Pulpit zarządczy
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <div style={{textAlign: 'justify'}}>
                        Pulpit zarządczy to centralny punkt w Aplikacji SRK, w którym prezentowane są
                        najważniejsze informacje finansowe podmiotu leczniczego.​
                        <br/>
                        W jednym miejscu użytkownik ma wgląd w podsumowanie sytuacji finansowej podmiotu, w tym
                        między innymi: koszty i przychody z podziałem na OPK, wynik finansowy poszczególnych
                        OPK; udziały poszczególnych OPK w kosztach i przychodach ogólnych; koszty z podziałem
                        według ich rodzaju i struktury. ​
                        <br/>
                        W Pulpicie zarządczym, użytkownik dzięki zagregowanym danym uzyska wgląd do wizualizacji
                        obrazujących sytuację finansową zarządzanego podmiotu.
                    </div>
                    {getBackBtn()}
                </CardBody>
            </Card>
            }
    </>)
}
export default UnusedViews
